import {Alert, styled} from '@mui/material';

const StyledAlert = styled(Alert)`
	& .MuiAlert-message {
		flex: 1;
	}
`;

export {StyledAlert};
